var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"chat-message"},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm._f("getMomentStr")(_vm.message.time_stamp)))]),_c('br'),_c('player-link',{attrs:{"playerId":_vm.message.user_id}}),_vm._v(" joined the club.\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }